export { AccountTitleModal } from "./AccountTitleModal"
export type { AccountTitleModalProps, UIStudentTitleOption } from "./AccountTitleModal"
